import { render, staticRenderFns } from "./CreateAssetGroup.vue?vue&type=template&id=42a17008&"
import script from "./CreateAssetGroup.vue?vue&type=script&lang=js&"
export * from "./CreateAssetGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports